import SurveySelector from './src/main';

/* istanbul ignore next */
SurveySelector.install = function(Vue) {
  Vue.component(SurveySelector.name, SurveySelector);
};

export default SurveySelector;
